import type { IntlKey } from 'locales';
import { range } from 'lodash-es';
import { FC, PropsWithChildren } from 'react';
import { useIntl } from 'react-intl';
import Skeleton from 'react-loading-skeleton';

import { ScrollableFixedHeightDiv } from '../see-more-publications-list';
import { SeeMorePublicationItemSkeleton } from './see-more-publication-item-skeleton';

export const SeeMorePublicationsListSkeleton: FC<
  PropsWithChildren<{
    titleKey?: IntlKey;
    itemsCount: number;
  }>
> = ({ titleKey, itemsCount }) => {
  const { formatMessage } = useIntl();
  return (
    <>
      <button className="btn btn-flat-secondary btn-xl align-self-end m-2">
        <Skeleton width="1em" />
      </button>
      {titleKey !== undefined && <h3 className="mb-4 px-md-5">{formatMessage({ id: titleKey })}</h3>}

      <ScrollableFixedHeightDiv className="container px-md-5">
        {range(0, itemsCount).map(k => (
          <SeeMorePublicationItemSkeleton key={k} />
        ))}
      </ScrollableFixedHeightDiv>
    </>
  );
};
